/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState, useEffect } from 'react';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import CustomDateRangePicker from '../../../components/CustomDateRangePicker/index'
import { Tooltip } from 'react-tooltip';

const Filter = ({
    handleApplyFilter,
    isFilterOpen,
    setIsFilterOpen,
    handleSetDate,
    DateRange,
    DateRangeError,
    SetDateRangeError,
    DateErrorClear,
    handleDatePickerValidation
}) => {

    const ref = useRef();

    const [active, setActive] = useState('status')

    useOnClickOutside(ref, () => {
        DateErrorClear()
        setIsFilterOpen(false)
    })


    return (
        <div className="relative">
            <img
                src="/assets/images/filter.svg"
                className="cursor-pointer p-3 hover:bg-[#ECD2E0] rounded-full"
                alt=""
                data-testid="filter-btn"
                data-tooltip-id="my-tooltip-14"
                onClick={() => setIsFilterOpen(!isFilterOpen)}
            />
            <Tooltip
                id="my-tooltip-14"
                place="bottom"
                content="Filter"
                zIndex = {9}
            />
            {isFilterOpen && <>
                <div ref={ref} className={`px-6 py-4 pb-6 absolute top-[40px] right-0 rounded-[4px] flex space-x-3 z-10 bg-white border border-[#F7D7E8] ${isFilterOpen ? 'h-auto' : 'h-fit'}`}>
                    <div className='w-full'>
                        <div className='min-w-[345px] relative z-0'>
                            <>
                                <p className='pb-3 font-[400] text-base text-[#000000B1]'>Date Range</p>
                                <div className='relative'>
                                    <CustomDateRangePicker
                                        start='from_date'
                                        end='end_date'
                                        handleSetDate={handleSetDate}
                                        DateRangeError={DateRangeError}
                                        SetDateRangeError={SetDateRangeError}
                                        DateRange={DateRange} />
                                </div>
                            </>
                            <div className='flex items-center justify-between mt-5'>
                                <button className='bg-primary px-[47.5px] py-[5px] w-[129px] text-[14px] leading-[22px] font-[400] rounded-[12px] text-[#FFFFFF]' data-testid="apply-btn" onClick={() => {
                                    if (handleDatePickerValidation()) {
                                        return
                                    }
                                    handleApplyFilter(false);
                                    setIsFilterOpen(false)
                                }}>
                                    Apply
                                </button>
                                <button data-testid="clear-btn" className="text-[14px] font-[400] leading-[22px] text-[#731748] whitespace-nowrap px-[47.5px] py-[5px] w-[129px]" onClick={() => {
                                    handleApplyFilter('all', 'clear');
                                    setIsFilterOpen(false)
                                }}>
                                    Clear All
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            }
        </div>
    );
}

export default Filter;
